import { useState, useCallback } from "react";
import axios from "axios";
import { computeApplicableSteps } from "../utils/onboarding";

const API_URL = process.env.REACT_APP_API_URL;

export function computeOnboardingState(onboarding, isCreator) {
  const safe = onboarding || {};
  const applicableSteps = computeApplicableSteps(isCreator);
  const stepsDone = safe.wizardStepsDone || [];
  const pendingSteps = applicableSteps.filter((step) => !stepsDone.includes(step));
  const wizardDismissed = Boolean(safe.wizardDismissed);

  return {
    applicableSteps,
    pendingSteps,
    showBanner: !wizardDismissed && pendingSteps.length > 0,
    shouldAutoOpenWizard: !safe.wizardShown,
    shouldAutoStartTour: !safe.tourCompleted,
  };
}

const readUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

export function useOnboarding() {
  const initialUser = readUser();
  const [onboarding, setOnboarding] = useState(initialUser.onboarding || {});
  const isCreator = Boolean(initialUser.isCreator);

  const patchOnboarding = useCallback(async (partial) => {
    const token = localStorage.getItem("token");
    const res = await axios.patch(
      `${API_URL}/users/me/onboarding`,
      partial,
      { headers: { Authorization: `Bearer ${token}` } },
    );

    setOnboarding(res.data);

    const currentUser = readUser();
    currentUser.onboarding = res.data;
    localStorage.setItem("user", JSON.stringify(currentUser));

    return res.data;
  }, []);

  return {
    onboarding,
    isCreator,
    patchOnboarding,
    ...computeOnboardingState(onboarding, isCreator),
  };
}
